<template>
<!-- Site wrapper -->
<div class="wrapper">
  <cabecalho tituloPagina="Configurações" />
  <menuLateral />

  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <!-- Main content -->
    <section class="content">
      <!-- Default box -->
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-5 col-sm-3 col-xl-2">
              <div class="nav flex-column nav-tabs h-20" id="vert-tabs-tab" role="tablist" aria-orientation="vertical">
                <a class="nav-link active" id="vert-tabs-agenda-tab" data-toggle="pill" href="#vert-tabs-agenda" role="tab" aria-controls="vert-tabs-agenda" aria-selected="true">
                  <b>Agenda</b> <i v-if="flagAbaAgenda" class="fas fa-exclamation-triangle"></i>
                </a>
              </div>
            </div>
            <div class="col-7 col-sm-9 col-xl-10">
              <b-alert v-model="flagsDeControle.avisoDeErroNoFormulario.exibir" variant="danger" fade dismissible>
                <span class="avisoDangerAlerta">{{flagsDeControle.avisoDeErroNoFormulario.mensagem}}</span>
              </b-alert>
              <div class="tab-content" id="vert-tabs-tabContent">
                <div class="tab-pane text-left fade active show" id="vert-tabs-agenda" role="tabpanel" aria-labelledby="vert-tabs-agenda-tab">
                  <Agenda />
                </div>
              </div>
            </div>
          </div>
        </div> <!-- ./ card-body ends-->
        <div class="card-footer text-right">
          <div class="row btn-group btn-group-justified" role="group">
            <div class="mr-1"><b-button class="botoes" variant="outline-success btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status" @click="salvarConfiguracoes()">Salvar</b-button></div>
            <router-link class="" to="/inicio">
              <b-button class="botoes" variant="outline-primary btn-sm mt-2" :disabled="flagsDeControle.manipulandoDados.status || flagsDeControle.carregandoDados.status">Cancelar</b-button>
            </router-link>
          </div>
        </div>
      </div> <!-- ./ card ends-->
    </section>
  </div>
  <!-- /.content-wrapper -->

</div>
<!-- ./wrapper -->
</template>

<script>
import Configuracoes from './js/configuracoes'
export default Configuracoes
</script>

<style scoped>
@import "./scss/configuracoes.scss";
</style>
